<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "grades",
  data() {
    return {};
  },
  created() {}
};
</script>
